<mat-form-field [formGroup]="form" style="width:100%">
  <input matInput [matDatepicker]="picker" [formControlName]="item.name" [placeholder]="item.label" [required]="item.required">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  <mat-hint></mat-hint>
  <ng-container *ngFor="let validation of item.validations;" ngProjectAs="mat-error">
    <mat-error *ngIf="form.get(item.name).hasError(validation.name)">{{validation.message}}</mat-error>
  </ng-container>
</mat-form-field>